module.exports = __webpack_public_path__ + "static/media/20210212_230054_795_IMG_2303.23e0b2c2.jpg";